import { VariantPicker } from "theme";

export class GTCDynamicSwatches extends VariantPicker {
    constructor() {
        super();

        this.matchingSelect = this.matchingSelect.bind(this);

        this.dom = {
            form: document.forms[this.getAttribute("form-id")]
        }

        this.settings = {
            hideSoldOutVariants: this.getAttribute("hide-sold-out-variants") === "true"
        }
    }

    connectedCallback() {
        if (this.dom.form) {
            this.dom.form.addEventListener("change", async () => await this.matchingSelect());
        }

        this.veryfyMatchingElements();
        super.connectedCallback();
    }

    disconnectedCallback() {
        if (this.dom.form) {
            this.dom.form.removeEventListener("change", async () => await this.matchingSelect());
        }
        super.disconnectedCallback();
    }

    async veryfyMatchingElements() {
        const formElements = Array.from(this.dom.form.elements);
        if (formElements.length === 0) {
            return;
        }

        const dataLabels = formElements.map(element => element.dataset.label);
        const uniqueDataLabels = [...new Set(dataLabels)];
        const matchingElements = formElements.filter(element => uniqueDataLabels.includes(element.dataset.label));
        const matchingElementsWithDisabledHtmlLabels = matchingElements.filter(element =>  element.parentElement.querySelector("[for='" + element.id + "']")?.classList.contains("is-disabled"));

        matchingElementsWithDisabledHtmlLabels.forEach(element => {
            const dataLabel = element.dataset.label;
            const matchingElement = matchingElements.find(element => element.dataset.label === dataLabel);
            if (matchingElement) {
                matchingElement.parentElement.querySelector("[for='" + matchingElement.id + "']").classList.add("is-disabled");
                if (this.settings.hideSoldOutVariants) {
                    matchingElement.disabled = true;
                }
            }
        });
    }

    async matchingSelect() {
        const formElements = Array.from(this.dom.form.elements);
        if (formElements.length === 0) {
            return;
        }

        const firstSelectedElement = formElements.find(element => element.checked === true);
        const firstSelectedElementLabel = firstSelectedElement ? firstSelectedElement.dataset.label : undefined;
        const firstSelectedElementFieldset = firstSelectedElement ? firstSelectedElement.closest("fieldset") : undefined;
        const firstSelectedElementFieldsetLabel = firstSelectedElementFieldset ? firstSelectedElementFieldset.querySelector("span") : undefined;
        const matchingElements = formElements.filter(element => element.dataset.label === firstSelectedElementLabel);
        if (matchingElements.length > 0) {
            firstSelectedElementFieldsetLabel.textContent = firstSelectedElementLabel;
            matchingElements.forEach(element => {
                element.click();
            });
        }
    }
}

customElements.define("gtc-bundle-variant-picker", GTCDynamicSwatches);